import React, { createContext, useState, useContext } from 'react';

const PendingStateContext = createContext();

export const PendingStateProvider = ({ children }) => {
  const [pendingEmpty, setPendingEmpty] = useState(false);
  const updatePendingState = (isEmpty) => {
    setPendingEmpty(isEmpty);
  };

  return (
    <PendingStateContext.Provider value={{ pendingEmpty, updatePendingState }}>
      {children}
    </PendingStateContext.Provider>
  );
};

export const usePendingState = () => {
  const context = useContext(PendingStateContext);
  if (!context) {
    throw new Error('usePendingState must be used within a PendingStateProvider');
  }
  return context;
};